import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import login from '@/views/auth/login'
import registro from '@/views/auth/registro'
import logout from '@/views/auth/logout'
import datospersonales from '@/views/usuarios/datos_personales/formulario'
import checkout from '@/views/suscripciones/checkout'
import resultado from '@/views/suscripciones/resultado'

const router = new VueRouter({
    mode: 'history',
    linkExactActiveClass: 'is-active',
    routes: [
        {
            path: '/',
            name: 'raiz',
            component: login
        },
        {
            path: '/login',
            name: 'login',
            component: login
        },  
        {
            path: '/registro',
            name: 'registro',
            component: registro
        },         
        {
            path: '/logout',
            name: 'logout',
            component: logout,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: require('@/views/dashboard').default,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/usuarios',
            name: 'usuarios',
            component: require('@/views/usuarios').default,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/plataformas',
            name: 'plataformas',
            component: require('@/views/plataforma').default,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/canales',
            name: 'canales',
            component: require('@/views/canales').default,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/listado_post/:usuario',
            name: 'listado_post',
            component: require('@/views/listado_post').default,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/generar_ideas/:usuario/:videoId/:idPosts',
            name: 'generar_ideas',
            component: require('@/views/listado_ideas').default,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/suscripcion',
            name: 'suscripcion',
            component: require('@/views/suscripciones').default,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/carrito/:plan',
            name: 'carrito',
            component: checkout,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/resultado-transaccion',
            name: 'resultado',
            component: resultado,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/datos-personales',
            name: 'datos_personales',
            component: datospersonales,
            meta: {
                requiresAuth: true
            }
        },
    ]
})

export default router
